// This file contains helper functions to generate unique IDs for different entities.
export const userMsgId   = (base: number) => base + 1;
export const gptMsgId    = (base: number) => base + 1_000_000;
export const nextMsgId   = (base: number) => base + 2_000_000;
